<template>
  <div>
    <general-top-bar :title="$t('reports.orderFromReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-4" v-if="locations.length">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <option
                v-for="loc in locations"
                :key="loc.id"
                :label="loc.name"
                :value="loc.id"
              >{{loc.name}}</option>
            </select>
          </div>
        </div>
        <div :class="locations.length ? 'col-md-4' : 'col-md-6'">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('dashboard.selectedOrderFormFlags')}}</label>
            <select class="form-control mar-bt-15" v-model="filterOrderSource">
              <option value="">{{$t('general.all')}}</option>
              <option
                v-for="opt in orderSourceFilterOptions"
                :key="opt.value"
                :value="opt.value"
              >{{ opt.label }}</option>
            </select>
          </div>
        </div>
        <div :class="locations.length ? 'col-md-4' : 'col-md-6'">
          <div class="mb-3 w-100">
            <label class="form-label text-start w-100">{{$t('reports.paymentMethod')}}</label>
            <select class="form-control mar-bt-15" v-model="filterPaymentMethod">
              <option value="">{{$t('general.all')}}</option>
              <optgroup
                v-for="group in paymentMethodFilterGroups"
                :key="group.key"
                :label="group.label"
              >
                <option
                  v-for="opt in group.options"
                  :key="opt.value"
                  :value="opt.value"
                >{{ opt.label }}</option>
              </optgroup>
            </select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <div class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </div>
        </p>
        <div class="pull-left search-button-reports">
          <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
        </div>
        <div class="search-button-reports form-group pull-left">
          <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="exportData()">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
        </div>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:59</b></p>
      </div>

      <div class="col-md-12">
        <div class="card-content total-pagination reports-center-columns">
          <chart-bars-card
            v-loading="loading"
            :chart-data="topProductSales.data"
            :chart-options="topProductSales.options"
            ref="topProductSales"
          >
            <template v-if="noData">
              <div class="no-data-message" style="text-align: center; margin: 20px;">
                <h3>{{ $t('reports.noDataAvailable') }}</h3>
              </div>
            </template>
            <div slot="header">
            </div>
            
            <div slot="footer">
              <div class="chart-legend" style="display: flex; flex-wrap: wrap;">
                <div
                  v-for="(label, index) in topProductSales.data.labels"
                  :key="index"
                  style="display: flex; align-items: center; margin-right: 12px;"
                >
                  <i
                    class="fa fa-circle"
                    :style="{ color: colors[index % colors.length], marginRight: '5px' }"
                  ></i>
                  <span>{{ label }} - {{ formatReportAmount(topProductSales.data.series[0][index]) }}</span>
                </div>
              </div>
            </div>
          </chart-bars-card>
        </div>
      </div>

      <!-- Totals Section -->
      <div v-if="hasReportTotals" class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <div class="card center-sales-report-stats" style="height: 100% !important;">
              <div class="card-content" v-loading="loading">
                <div class="report-container">
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.total')}}</div>
                    <div class="report-col right-align">{{formatReportAmount(totalAmount)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.orderCounter')}}</div>
                    <div class="report-col right-align">{{totalCounter}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.fiscalReceiptsAmount')}}</div>
                    <div class="report-col right-align">{{formatReportAmount(fiscalTotal)}}</div>
                  </div>
                  <div class="report-row">
                    <div class="report-col left-align">{{$t('reports.nonFiscalReceiptsAmount')}}</div>
                    <div class="report-col right-align">{{formatReportAmount(nonFiscalTotal)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" style="margin-top: 15px;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          class="report-sales"
          key="sales-table"
          style="width: 100%"
          ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="90" prop="order_source_label" :label="$t('reports.source')">
              <template slot-scope="props">
                {{ orderSourceLabel(props.row.order_source_label, props.row.order_source_id) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="100" prop="payment_method" :label="$t('reports.paymentMethod')">
              <template slot-scope="props">
                {{ paymentMethodLabel(props.row.payment_method) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="70" prop="counter" :label="$t('reports.orderCounter')">
              <template slot-scope="props">
                {{ parseReportNumber(props.row.counter) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="90" prop="total" :label="$t('reports.salesChart')">
              <template slot-scope="props">
                {{ formatReportAmount(props.row.total) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="90" prop="fiscal_total" :label="$t('reports.fiscalReceiptsAmount')">
              <template slot-scope="props">
                {{ formatReportAmount(props.row.fiscal_total) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="90" prop="non_fiscal_total" :label="$t('reports.nonFiscalReceiptsAmount')">
              <template slot-scope="props">
                {{ formatReportAmount(props.row.non_fiscal_total) }}
              </template>
            </el-table-column>
        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import SearchableMultiSelect from 'src/components/UIComponents/Inputs/SearchableMultiSelect.vue'

const ORDER_SOURCE_LABELS = {
  0: 'unknown',
  1: 'kiosk',
  2: 'qr',
  3: 'pos',
  4: 'app',
  5: 'website',
  6: 'glovo',
  7: 'wolt',
  8: 'bolt'
}

// Same grouping as summary cards in ReportsSales.vue
const SALES_REPORT_PAYMENT_GROUPS = [
  {
    key: 'cash',
    labelKey: 'reports.totalCash',
    methods: ['CASH', 'GLOVO_CASH', 'BOLT_CASH', 'WOLT_CASH']
  },
  {
    key: 'online',
    labelKey: 'reports.totalOnline',
    methods: ['CARD', 'ONLINE']
  },
  {
    key: 'card',
    labelKey: 'reports.totalCard',
    methods: ['POS', 'CARD_POS', 'SPLIT']
  },
  {
    key: 'credit',
    labelKey: 'reports.totalCredit',
    methods: ['BOLT_CARD', 'GLOVO_CARD', 'WOLT_CARD']
  },
  {
    key: 'nonFiscal',
    labelKey: 'reports.totalNonFiscal',
    methods: ['PROTOCOL', 'MANCARE_PERSONAL', 'VIRAMENT', 'ROOM', 'EVENT', 'FOLIO']
  }
]

const SALES_REPORT_PAYMENT_METHODS = new Set(
  SALES_REPORT_PAYMENT_GROUPS.reduce((acc, group) => acc.concat(group.methods), [])
)

const PAYMENT_METHOD_ALIASES = {
  online: 'ONLINE',
  glovo_cash: 'GLOVO_CASH',
  'glovo cash': 'GLOVO_CASH',
  glovo_card: 'GLOVO_CARD',
  'glovo card': 'GLOVO_CARD',
  glovo: 'GLOVO',
  bolt_cash: 'BOLT_CASH',
  'bolt cash': 'BOLT_CASH',
  bolt_card: 'BOLT_CARD',
  'bolt card': 'BOLT_CARD',
  bolt: 'BOLT',
  wolt_cash: 'WOLT_CASH',
  'wolt cash': 'WOLT_CASH',
  wolt_card: 'WOLT_CARD',
  'wolt card': 'WOLT_CARD',
  wolt: 'WOLT',
  card_pos: 'CARD_POS',
  cash_machine: 'CASH_MACHINE',
  pos_kiosk: 'POS_KIOSK',
  mancare_personal: 'MANCARE_PERSONAL',
  viva_intent: 'VIVA_INTENT'
}

export default {
  components: {
    GeneralTopBar,
    SearchableMultiSelect,
    [DatePicker.name]: DatePicker,
    ChartCard,
    ChartBarsCard,
    ChartPieCard
  },
  props: {
    isOrderFrom: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOrderFrom () {
      if (this.isOrderFrom) {
        this.getOrders()
        this.verifyUserLocations()
        this.verifyUserMethods()
      }
    }
  },
  computed: {
    hasReportTotals () {
      return this.totalCounter > 0 || this.ordersTableData.total > 0
    },
    orderSourceFilterOptions () {
      return Object.keys(ORDER_SOURCE_LABELS).map(id => ({
        value: String(id),
        label: this.orderSourceLabel(ORDER_SOURCE_LABELS[id], id)
      }))
    },
    paymentMethodFilterGroups () {
      const buildOption = (value) => ({
        value,
        label: value === '__unpaid__'
          ? this.$t('reports.unpaid')
          : this.paymentMethodLabel(value)
      })

      const groups = SALES_REPORT_PAYMENT_GROUPS.map(group => {
        const seen = new Set()
        const options = group.methods
          .map(method => this.normalizePaymentMethod(method))
          .filter(value => {
            if (seen.has(value)) return false
            seen.add(value)
            return true
          })
          .map(buildOption)
        return { key: group.key, label: this.$t(group.labelKey), options }
      })

      groups.push({
        key: 'other',
        label: this.$t('reports.other'),
        options: [buildOption('__unpaid__')]
      })

      return groups
    }
  },
  // created () {
  //   this.getOrders()
  //   this.verifyUserLocations()
  //   this.verifyUserMethods()
  // },
  data () {
    return {
      valid_from: '00:00',
      valid_to: '23:59',
      selectedCategories: [],
      selectedTopCategories: [],
      ordersTableData: {
        data: [],
        total: 0
      },
      filterOrderSource: '',
      filterPaymentMethod: '',
      totalAmount: 0,
      totalCounter: 0,
      fiscalTotal: 0,
      fiscalCounter: 0,
      nonFiscalTotal: 0,
      nonFiscalCounter: 0,
      topProductSales: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          seriesBarDistance: 20,
          showArea: true,
          height: '500px',
          axisX: {
            scaleMinSpace: 50,
            showGrid: false
          },
          axisY: {
            onlyInteger: true
          }
        }
      },
      loading: true,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total'
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      salesReportChart: {
        title: '',
        data: {
          labels: [],
          series: []
        },
        options: {
          showArea: true,
          height: '250px',
          width: '250px'
        }
      },
      colors: [
        '#f44336', // red
        '#2196f3', // blue
        // '#4caf50', // green
        '#ff9800', // orange
        '#9c27b0', // purple
        '#00bcd4', // cyan
        // '#e91e63', // pink
        '#8bc34a', // light green
        '#ffc107', // amber
        '#3f51b5', // indigo
        '#ff5722', // deep orange
        '#795548', // brown
        '#607d8b', // blue grey
        '#009688', // teal
        '#cddc39', // lime
        '#673ab7', // deep purple
        '#03a9f4', // light blue
        '#aed581', // soft green
        '#ffb74d', // soft orange
        '#ba68c8'  // soft purple
      ],
      noData: false
    }
  },
  methods: {
    parseReportNumber (value) {
      const n = Number(value)
      return isNaN(n) ? 0 : n
    },
    formatReportAmount (value) {
      const amount = Number(this.parseReportNumber(value).toFixed(2))
      if (amount === 0) {
        const currency = this.getCurrencySymbol(this.getCompanyDetail('currency'))
        const position = this.getCurrencyPosition(this.getCompanyDetail('currency'))
        const formatted = '0.00'
        return position === 'left' ? currency + formatted : formatted + ' ' + currency
      }
      return this.formatMoneyAmount(amount)
    },
    normalizePaymentMethod (method) {
      if (method == null || method === '' || method === 'unpaid') {
        return '__unpaid__'
      }
      const raw = String(method).trim()
      const lower = raw.toLowerCase()
      if (PAYMENT_METHOD_ALIASES[lower]) {
        return PAYMENT_METHOD_ALIASES[lower]
      }
      const upperUnderscore = raw.toUpperCase().replace(/\s+/g, '_')
      if (SALES_REPORT_PAYMENT_METHODS.has(upperUnderscore)) {
        return upperUnderscore
      }
      if (SALES_REPORT_PAYMENT_METHODS.has(raw)) {
        return raw
      }
      return upperUnderscore
    },
    getPaymentMethodFilterValue (method) {
      return this.normalizePaymentMethod(method)
    },
    paginationChanged (query) {
      if (query.type === 'page') this.getOrders(query)
      if (query.type === 'size') this.getOrders(query)
      if (query.type === 'sort') this.getOrders(query)
    },
    buildReportRequestData () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }

      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      const fromDate = this.orders.valid[0] + ' ' + this.valid_from
      const toDate = this.orders.valid[1] + ' ' + this.valid_to

      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.filterOrderSource !== '') {
        data.order_source_id = this.filterOrderSource
      }

      if (this.filterPaymentMethod !== '') {
        data.payment_method = this.filterPaymentMethod === '__unpaid__'
          ? 'unpaid'
          : this.filterPaymentMethod
      }

      return data
    },
    orderSourceLabel (label, orderSourceId) {
      const resolvedLabel = label || ORDER_SOURCE_LABELS[orderSourceId]
      if (!resolvedLabel) return ''
      const key = 'orderFrom.' + resolvedLabel
      const translated = this.$t(key)
      if (translated !== key) return translated
      const upperKey = 'orderFrom.' + String(resolvedLabel).toUpperCase()
      const upperTranslated = this.$t(upperKey)
      return upperTranslated !== upperKey ? upperTranslated : resolvedLabel
    },
    paymentMethodLabel (method) {
      const normalized = this.normalizePaymentMethod(method)
      if (normalized === '__unpaid__') {
        return this.$t('reports.unpaid')
      }
      const key = 'paymentTypes.' + normalized
      const translated = this.$t(key)
      if (translated !== key) return translated
      const upperKey = 'paymentTypes.' + String(normalized).toUpperCase()
      const upperTranslated = this.$t(upperKey)
      if (upperTranslated !== upperKey) return upperTranslated
      if (normalized === 'GLOVO_CASH') return this.$t('reports.glovoCash')
      if (normalized === 'GLOVO_CARD') return this.$t('reports.glovoCard')
      if (normalized === 'BOLT_CASH') return this.$t('reports.boltCash')
      if (normalized === 'BOLT_CARD') return this.$t('reports.boltCard')
      if (normalized === 'WOLT_CASH') return this.$t('reports.woltCash')
      if (normalized === 'WOLT_CARD') return this.$t('reports.woltCard')
      return normalized
    },
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))
        console.log(allowedLocations)
        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isOrderFrom) {
        return
      }
      const data = this.buildReportRequestData()
      const pageSize = query ? query.pageSize : 20
      const page = query ? query.page : 1

      this.loading = true

      this.apiRequest(
        '/reports/v2/order-from?page=' + page + '&pageSize=' + pageSize,
        'GET',
        data,
        response => {
          if (response.status) {
            const reportData = response.data || {}
            const tableRows = reportData.table_rows || []
            const pagination = response.pagination || {}

            this.ordersTableData.data = tableRows
            this.ordersTableData.total = pagination.total != null
              ? pagination.total
              : tableRows.length
            this.paginationProps.currentPage = pagination.page || page
            this.paginationProps.pageSize = pagination.perPage || pageSize

            if (tableRows.length || (pagination.total != null && pagination.total > 0)) {
              this.totalAmount = reportData.total || 0
              this.totalCounter = reportData.total_counter || 0
              this.fiscalTotal = reportData.fiscal_total || 0
              this.fiscalCounter = reportData.fiscal_counter || 0
              this.nonFiscalTotal = reportData.non_fiscal_total || 0
              this.nonFiscalCounter = reportData.non_fiscal_counter || 0
            } else {
              this.ordersTableData.data = []
              this.ordersTableData.total = 0
              this.paginationProps.currentPage = 1
              this.paginationProps.pageSize = pageSize
              this.totalAmount = 0
              this.totalCounter = 0
              this.fiscalTotal = 0
              this.fiscalCounter = 0
              this.nonFiscalTotal = 0
              this.nonFiscalCounter = 0
            }

            this.topProductSales.options.chartPadding = {
              top: 30,
              right: 10,
              bottom: 20,
              left: 20
            }

            const sources = reportData.source || []
            const sales = reportData.sales || []

            if (!sources.length) {
              this.$nextTick(() => {
                this.topProductSales.data.labels = []
                this.topProductSales.data.series = [[]]
                this.noData = true

                if (this.$refs.topProductSales.chart) {
                  this.$refs.topProductSales.initChartAndReturn()
                }

                return false
              })
            }

            this.noData = false
            this.topProductSales.data.labels = sources.map(element => this.orderSourceLabel(element))
            this.topProductSales.data.series = [sales]

            this.$nextTick(() => {
              this.$refs.topProductSales.initChartAndReturn()

              if (this.$refs.topProductSales.chart) {
                this.$refs.topProductSales.chart.on('draw', data => {
                  if (data.type === 'bar') {
                    data.element.attr({
                      style: `stroke: ${this.colors[data.index % this.colors.length]}; stroke-width: 60px;`
                    })
                  }
                })
              }
            })
          } else {
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
            this.topProductSales.data.labels = []
            this.topProductSales.data.series = [[]]
            this.noData = true

            if (this.$refs.topProductSales.chart) {
              this.$refs.topProductSales.initChartAndReturn()
            }

            swal(
              '',
              response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
              'error'
            )
          }

          this.$nextTick(() => {
            this.loading = false
          })
        }
      )
    },
    updateData () {
      this.getOrders()
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    },
    currentDate () {
      return moment().format('DD-MM-YYYY') + '.xls'
    },
    exportData () {
      const data = this.buildReportRequestData()

      this.loading = true
      this.apiRequest('/reports/v2/order-from-download', 'GET', data, response => {
        if (response.status === true) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name)
          document.body.appendChild(link)
          link.click()
        } else {
          swal(
            '',
            this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.loading = false
      })
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/OrderFromReport.vue